import GL from '@luma.gl/constants';
import { ScatterplotLayer } from '@deck.gl/layers';
import customFragmentShader from './customShader/availableAllocatedImpressionsLayer.glsl';

export default class AvailableAllocatedImpressionsLayer extends ScatterplotLayer {
  initializeState(params) {
    super.initializeState(params);

    this.getAttributeManager().addInstanced({
      availableImpressionsRatio: { size: 1, accessor: 'getAvailableImpressionsRatio', defaultValue: 0 },
      allocatedImpressionsRatio: { size: 1, accessor: 'getAllocatedImpressionsRatio', defaultValue: 0 },
      mapElementSize: { size: 1, accessor: 'getMapElementSize', defaultValue: 0 },
      isVisible: { size: 1, accessor: 'getIsVisible', defaultValue: 1 },
      assetColor: { size: 4, type: GL.FLOAT, accessor: 'getAssetColor', defaultValue: [0, 0, 0, 0] },
      firstBarColor: { size: 3, type: GL.UNSIGNED_BYTE, accessor: 'getFirstBarColor', defaultValue: [0, 0, 0, 0] },
      secondBarColor: { size: 4, type: GL.UNSIGNED_BYTE, accessor: 'getSecondBarColor', defaultValue: [0, 0, 0, 0] },
    });
  }

  draw({ uniforms }) {
    super.draw({
      uniforms: {
        ...uniforms,
        innerRadius: this.props.innerRadius,
        isAvailabilityClusterVisible: this.props.isAvailabilityClusterVisible,
        isAllocationClusterVisible: this.props.isAllocationClusterVisible,
        isImpressionsClusterVisible: this.props.isImpressionsClusterVisible,
      },
    });
  }

  getShaders() {
    return {
      ...super.getShaders(),
      fs: customFragmentShader,
      inject: {
        'vs:#decl': `
          attribute float availableImpressionsRatio;
          attribute float allocatedImpressionsRatio;
          attribute float mapElementSize;
          attribute float isVisible;
          attribute vec4 assetColor;
          attribute vec3 firstBarColor;
          attribute vec4 secondBarColor;

          varying float vAvailableRatio;
          varying float vAllocatedRatio;
          varying float vMapElementSize;
          varying float vIsVisible;
          varying vec4 vAssetColor;
          varying vec3 vFirstBarColor;
          varying vec4 vSecondBarColor;
         `,
        'vs:#main-end': `
          vAvailableRatio = availableImpressionsRatio;
          vAllocatedRatio = allocatedImpressionsRatio;
          vMapElementSize = mapElementSize;
          vIsVisible = isVisible;
          vAssetColor = assetColor;
          vFirstBarColor = firstBarColor;
          vSecondBarColor = secondBarColor;
         `,
      },
    };
  }
}

AvailableAllocatedImpressionsLayer.layerName = 'AvailableAllocatedImpressionsLayer';

AvailableAllocatedImpressionsLayer.defaultProps = {
  radiusUnits: 'pixels',
  innerRadius: 1,
  getAvailableImpressionsRatio: { type: 'accessor', value: 0 },
  getAllocatedImpressionsRatio: { type: 'accessor', value: 0 },
  getMapElementSize: { type: 'accessor', value: 0 },
  getIsVisible: { type: 'accessor', value: 1 },
  getAssetColor: { type: 'accessor', value: [0, 0, 0, 0] },
  getFirstBarColor: { type: 'accessor', value: [0, 0, 0, 0] },
  getSecondBarColor: { type: 'accessor', value: [0, 0, 0, 0] },
};
